export default "__VITE_ASSET__DD2m1iDV__"